import React, { Component } from "react";
import { connect } from "react-redux";
import "./style.css";
import "../../../../index.css";
import { actions as subjectqueryActions } from "../../../../redux/modules/subjectquery";
import { get } from "../../../../utils/request";
let shake;
class SubjectQuery extends Component {
  constructor(props) {
    super(props);
    this.state = {
      css: {},
      subjectFilterId: [0, 0, 0, 0, 0, 0, 0],
      errorTip: "",
      shake_visible: false,
      suject: [],
    };
  }
  componentWillMount() {
    this.requestShareConfig();
  }
  componentDidMount() {
    this.fixCss();
    document.title = "浙考之家-万能选科-按选科查";
  }
  componentWillUnmount() {
    clearTimeout(shake);
  }
  render() {
    const { subjectFilterId, errorTip, shake_visible } = this.state;
    return (
      <div
        style={{ height: 700, overflow: "auto" }}
        className="subjectQuery_box"
      >
        <div className="subjectQuery_box_desc">
          <img
            alt=""
            src={require("../../../../images/powerful/subjectquery/subject-desc.png")}
          ></img>
        </div>
        <div className="subjectQuery_box_img0">
          <div className="text_align_center">
            <img
              onClick={() => this.handleSelectSubject(0, 1)}
              className="fl"
              alt=""
              src={
                subjectFilterId[0] === 0
                  ? require("../../../../images/powerful/subjectquery/physics.png")
                  : require("../../../../images/powerful/subjectquery/physics-select.png")
              }
            ></img>
            <img
              onClick={() => this.handleSelectSubject(1, 2)}
              style={{ margin: "0 auto" }}
              alt=""
              src={
                subjectFilterId[1] === 0
                  ? require("../../../../images/powerful/subjectquery/chemistry.png")
                  : require("../../../../images/powerful/subjectquery/chemistry-select.png")
              }
            ></img>
            <img
              onClick={() => this.handleSelectSubject(2, 3)}
              className="fr"
              alt=""
              src={
                subjectFilterId[2] === 0
                  ? require("../../../../images/powerful/subjectquery/biology.png")
                  : require("../../../../images/powerful/subjectquery/biology-select.png")
              }
            ></img>
          </div>
        </div>
        <div className="subjectQuery_box_img1">
          <div className="text_align_center">
            <img
              onClick={() => this.handleSelectSubject(3, 4)}
              className="fl"
              alt=""
              src={
                subjectFilterId[3] === 0
                  ? require("../../../../images/powerful/subjectquery/politics.png")
                  : require("../../../../images/powerful/subjectquery/politics-select.png")
              }
            ></img>
            <img
              onClick={() => this.handleSelectSubject(4, 5)}
              style={{ margin: "0 auto" }}
              alt=""
              src={
                subjectFilterId[4] === 0
                  ? require("../../../../images/powerful/subjectquery/history.png")
                  : require("../../../../images/powerful/subjectquery/history-select.png")
              }
            ></img>
            <img
              onClick={() => this.handleSelectSubject(5, 6)}
              className="fr"
              alt=""
              src={
                subjectFilterId[5] === 0
                  ? require("../../../../images/powerful/subjectquery/geography.png")
                  : require("../../../../images/powerful/subjectquery/geography-select.png")
              }
            ></img>
          </div>
        </div>
        <div className="subjectQuery_box_img2">
          <img
            onClick={() => this.handleSelectSubject(6, 7)}
            alt=""
            src={
              subjectFilterId[6] === 0
                ? require("../../../../images/powerful/subjectquery/technology.png")
                : require("../../../../images/powerful/subjectquery/technology-select.png")
            }
          ></img>
        </div>
        <div
          className={
            shake_visible === true
              ? "subjectQuery_box_error shake"
              : "subjectQuery_box_error"
          }
        >
          {errorTip}
        </div>
        <div
          onClick={() => this.handleConfim()}
          className="subjectQuery_box_btn"
        >
          确定
        </div>
      </div>
    );
  }
  fixCss = () => {
    let minHeight = window.innerHeight;
    this.setState({
      css: {
        minHeight: minHeight,
      },
    });
  };
  /**
   * 移除错误提示语抖动效果
   */
  handleRemoveShake = () => {
    shake = setTimeout(() => {
      this.setState({
        shake_visible: false,
      });
    }, 800);
  };
  /**
   * 当点击选科执行的操作
   * @param {点击选科的索引} index
   * @param {选科在数据库配置的id} subjectId
   */
  handleSelectSubject = (index, subjectId) => {
    this.setState((prevState) => {
      const nextState = prevState;
      nextState.subjectFilterId[index] =
        nextState.subjectFilterId[index] === 1 ? 0 : 1;
      if (nextState.subjectFilterId[index] === 1) {
        nextState.suject.push(subjectId);
      } else {
        this.handleRemove(subjectId, nextState.suject);
      }
      if (nextState.suject.length > 3) {
        nextState.errorTip = "∗ 选科最多不能超过三科";
        nextState.shake_visible = true;
        nextState.subjectFilterId[index] = 0;
        this.handleRemove(subjectId, nextState.suject);
      } else {
        nextState.errorTip = "";
      }
      return nextState;
    });
    this.handleRemoveShake();
  };
  /**
   * 点击确认
   */
  handleConfim = () => {
    if (this.state.suject.length === 0) {
      this.setState({
        ...this.state,
        errorTip: "∗ 请至少选择1科",
        shake_visible: true,
      });
      this.handleRemoveShake();
    } else {
      //存两份数据 一份存sessionStorage，一份存redux 。
      const { dispatch } = this.props;
      dispatch(subjectqueryActions.cacheSubject(this.state.suject));
      sessionStorage.setItem("suject", JSON.stringify(this.state.suject));
      this.props.history.push("/subjectquery/list");
    }
  };
  /**
   * 删除指定数组元素
   */
  handleRemove = (val, data) => {
    var index = this.getIndexOf(val, data);
    if (index > -1) {
      data.splice(index, 1);
    }
  };
  //获取元素在数组的下标
  getIndexOf = function (val, data) {
    for (var i = 0; i < data.length; i++) {
      if (data[i] === val) {
        return i;
      }
    }
    return -1;
  };
  /**
   * 请求分享的配置
   */
  requestShareConfig = () => {
    const url = window.location.href;
    get("/api/share/config?url=" + url).then((res) => {
      if (res.status === "success") {
        let signature = res.data.signature;
        let timestamp = res.data.timestamp;
        let noncestr = res.data.nonceStr;
        let appid = res.data.appId;
        window.wx.config({
          debug: false, // 开启调试模式,调用的所有public/v1的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
          appId: appid, // 必填，公众号的唯一标识
          timestamp: timestamp, // 必填，生成签名的时间戳
          nonceStr: noncestr, // 必填，生成签名的随机串
          signature: signature, // 必填，签名
          jsApiList: ["onMenuShareAppMessage", "onMenuShareTimeline"], // 必填，需要使用的JS接口列表
        });

        window.wx.ready(function () {
          //分享给朋友
          window.wx.onMenuShareAppMessage({
            title: "浙考之家-万能选科-按选科查", // 分享标题
            desc: "一站式升学、就业规划，找浙考之家", // 分享描述
            link: url, // 分享.链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
            imgUrl: "https://resource.zhekaozhijia.com/common/icon/logo.png", // 分享图标s
            type: "link", // 分享类型,music、video或link，不填默认为link
            dataUrl: "", // 如果type是music或video，则要提供数据链接，默认为空
            success: function () {
              // 用户确认分享后执行的回调函数
              //                 alert("OK");
            },
            cancel: function () {
              // 用户取消分享后执行的回调函数
              //                 alert("fail");
            },
          });
          //分享给朋友圈
          window.wx.onMenuShareTimeline({
            title: "浙考之家-万能选科-按选科查", // 分享标题
            link: url, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
            imgUrl: "https://resource.zhekaozhijia.com/common/icon/logo.png", // 分享图标
            success: function () {
              // 用户确认分享后执行的回调函数
            },
          });
        });
      }
    });
  };
}

export default connect()(SubjectQuery);



// WEBPACK FOOTER //
// ./src/containers/PowerfulQuery/components/SubjectQuery/index.js